<script setup>
import { ref, computed } from 'vue';
import ReportHeader from './components/ReportHeader.vue';
import SummaryReports from './components/SummaryReports.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';
import { usePolicy } from 'dashboard/composables/usePolicy';

const summarReportsRef = ref(null);

const { checkPermissions } = usePolicy();

const hasFullReports = computed(() =>
  checkPermissions(['administrator', 'report_manage'])
);

const getterKey = computed(() =>
  hasFullReports.value ? 'teams/getTeams' : 'teams/getLedTeams'
);

const onDownloadClick = () => {
  summarReportsRef.value.downloadReports();
};
</script>

<template>
  <ReportHeader
    :header-title="$t('TEAM_REPORTS.HEADER')"
    :header-description="$t('TEAM_REPORTS.DESCRIPTION')"
  >
    <V4Button
      :label="$t('TEAM_REPORTS.DOWNLOAD_TEAM_REPORTS')"
      icon="i-ph-download-simple"
      size="sm"
      @click="onDownloadClick"
    />
  </ReportHeader>

  <SummaryReports
    ref="summarReportsRef"
    action-key="summaryReports/fetchTeamSummaryReports"
    :getter-key="getterKey"
    fetch-items-key="teams/get"
    summary-key="summaryReports/getTeamSummaryReports"
    type="team"
  />
</template>
